import React from "react";

export interface IconSvgProps extends Omit<React.SVGProps<SVGSVGElement>, "viewBox"> {
  viewBox: {
    minX: number;
    minY: number;
    width: number;
    height: number;
  };
  size?:
    | number
    | {
        width?: number;
        height?: number;
      };
}

export const IconSvg: React.FC<IconSvgProps> = ({ viewBox, size, width, height, ...props }) => {
  // TODO: Implement?
  // const widthRatio = viewBox.width / viewBox.height;
  // const heightRatio = viewBox.height / viewBox.width;

  // const { width, height } = React.useMemo(() => {
  //   if (!size) {
  //     return {
  //       width: viewBox.width,
  //       height: viewBox.height,
  //     };
  //   }

  //   if (typeof size === "number") {
  //     const height = size < viewBox.minY ? viewBox.minY : size;
  //     return {
  //       width: height * widthRatio,
  //       height,
  //     };
  //   }

  //   const width = !size.width || size.width < viewBox.minX ? viewBox.minX : size.width;
  //   const height = !size.height || size.height < viewBox.minY ? viewBox.minY : size.height;

  //   if (size?.width !== undefined && size.height === undefined) {
  //     return {
  //       width,
  //       height: width * heightRatio,
  //     };
  //   }

  //   if (size.width === undefined && size?.height !== undefined) {
  //     return {
  //       width: height * widthRatio,
  //       height,
  //     };
  //   }

  //   return { width, height };
  // }, [size]);

  const dimensions = React.useMemo(() => {
    if (!size) {
      if (width === undefined && height === undefined) {
        return { width: viewBox.width, height: viewBox.height };
      }

      return { width, height };
    }
    if (typeof size === "number") return { width: size, height: size };

    return size;
  }, [size, width, height, viewBox]);

  const svgProps: React.SVGProps<SVGSVGElement> = {
    viewBox: `${viewBox.minX} ${viewBox.minY} ${viewBox.width} ${viewBox.height}`,
    width: dimensions.width,
    height: dimensions.height,
    display: "block",
    ...props,
  };

  return <svg xmlns="http://www.w3.org/2000/svg" {...svgProps} />;
};

export type IconColor = Exclude<React.CSSProperties["color"], undefined>;

export type IconFnProps<C extends IconColor, P extends Record<string, unknown>> = P & {
  size?: IconSvgProps["size"];
  color?: C;
} & Omit<React.SVGProps<SVGSVGElement>, "viewBox">;

export type IconFn<C extends IconColor = IconColor, P extends Record<string, unknown> = Record<string, unknown>> = (
  props: IconFnProps<C, P>
) => ReturnType<typeof IconSvg>;
